import { API, getAuth } from "../../lib/api";

/**
 * Phase 171 — stream one assistant turn over SSE (fetch + ReadableStream; axios cannot stream).
 *
 * streamAssistantMessage({ code, conversationId, text, signal, onEvent })
 *   onEvent(event, data) receives: meta | token | tool_start | tool_done | artifact | done | error
 * Resolves when the stream closes; rejects on HTTP / network failure (after emitting an `error` event).
 */
export async function streamAssistantMessage({ code, conversationId, text, signal, onEvent }) {
  const auth = getAuth();
  const res = await fetch(`${API}/t/${code}/assistant/conversations/${conversationId}/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream", ...(auth?.token ? { Authorization: `Bearer ${auth.token}` } : {}) },
    body: JSON.stringify({ text }),
    signal,
  });
  if (!res.ok || !res.body) {
    let detail = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      detail = typeof j?.detail === "string" ? j.detail : detail;
    } catch { /* keep status text */ }
    onEvent?.("error", { message: detail, http: res.status });
    throw new Error(detail);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  const dispatch = (block) => {
    let event = "message";
    const data = [];
    for (const line of block.split("\n")) {
      if (line.startsWith("event:")) event = line.slice(6).trim();
      else if (line.startsWith("data:")) data.push(line.slice(5).trimStart());
    }
    if (!data.length) return;
    let payload = {};
    try { payload = JSON.parse(data.join("\n")); } catch { payload = { raw: data.join("\n") }; }
    onEvent?.(event, payload);
  };
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) >= 0) {
      const block = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      if (block.trim()) dispatch(block);
    }
  }
  if (buffer.trim()) dispatch(buffer);
}
